fragment Faq on faqBlock_Entry {
    ... on faqBlock_Entry {
        title: blockTitle
        items: faqItems {
            ... on item_Entry {
                title: label
                content: richTextContent {
                    html
                }
            }
        }
    }
}
